<script>
export default {
  name: 'base-heading',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'h2',
      validator: (value) => {
        const validElements = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
        return validElements.indexOf(value) > -1
      }
    },
    underline: {
      type: Boolean,
      default: true
    }
  },
  render (h, context) {
    const compClasses = {
      heading: true,
      underlined: context.props.underline
    }
    return h(context.props.tag,
      {
        class: compClasses,
        attrs: context.data.attrs,
        staticStyle: context.data.staticStyle,
        staticClass: context.data.staticClass
      },
      [
        context.slots().default
      ])
  }
}
</script>

<style scoped lang="scss">
.heading {
  font-size: 2.4rem;
  font-weight: normal;
  text-transform: uppercase;
  padding-bottom: 0.8rem;
  margin-bottom: 2.4rem;

  &.underlined {
    border-bottom: 1px solid $form-border-color;
  }
}
</style>
